import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import React, { useContext } from 'react';
import { isNilOrEmpty } from '../../../../helpers/utils';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';
import HoursOperationType, { OperationDaySpec } from './HoursOperationType';
import Title from './Title';

type HoursOperationWidget = React.ComponentPropsWithoutRef<typeof HoursOperationType>;

interface Props {
  showTitle?: boolean;
  showDisclaimer?: boolean;
  showHoursBusStation?: boolean;
  showHoursPackageExpress?: boolean;
  showHoursBusTicketOffice?: boolean;
  hours?: Partial<
    Record<
      'hoursBusStation' | 'hoursPackageExpress' | 'hoursBusTicketingOffice',
      OperationDaySpec[]
    >
  >;
  titleStyles?: StyledProps;
  disclaimerStyles?: StyledProps;
  hoursBusStationStyles?: HoursOperationWidget;
  hoursPackageExpressStyles?: HoursOperationWidget;
  hoursBusTicketOfficeStyles?: HoursOperationWidget;
}

function HoursOperation({
  showTitle = true,
  showDisclaimer = true,
  showHoursBusStation = true,
  showHoursPackageExpress = true,
  showHoursBusTicketOffice = true,
  hours = {},
  titleStyles = {},
  disclaimerStyles = {},
  hoursBusStationStyles = {
    titleKey: 'cmp-bus-directory-map-bus-station',
  },
  hoursPackageExpressStyles = {
    titleKey: 'cmp-bus-directory-map-phoneNumberPackageExpress',
  },
  hoursBusTicketOfficeStyles = {
    titleKey: 'cmp-bus-directory-map-bus-ticketing-office',
  },
  ...props
}: StyledProps<Props>) {
  const { translate } = useContext(Context);
  return (
    <Box
      dataTestId="hoursOperationLayoutRow"
      className="station-item-hours-operation"
      paddingTop="2"
      borderTop={true}
      {...props}
    >
      {showTitle && (
        <Title
          marginBottom="1"
          leftIcon="clock"
          labelKey="cmp-bus-directory-map-hours-operation"
          {...titleStyles}
        />
      )}
      {showDisclaimer && (
        <Text {...disclaimerStyles}>
          {translate(
            'cmp-bus-directory-map-hours-operation-disclaimer',
            'Hours of Operation are subject to change. Please call the Greyhound bus station to verify hours before making travel arrangements.'
          )}
        </Text>
      )}
      {showHoursBusStation && !isNilOrEmpty(hours.hoursBusStation) && (
        <HoursOperationType {...hoursBusStationStyles} operationDays={hours.hoursBusStation} />
      )}
      {showHoursPackageExpress && !isNilOrEmpty(hours.hoursPackageExpress) && (
        <HoursOperationType
          {...hoursPackageExpressStyles}
          operationDays={hours.hoursPackageExpress}
        />
      )}
      {showHoursBusTicketOffice && !isNilOrEmpty(hours.hoursBusTicketingOffice) && (
        <HoursOperationType
          {...hoursBusTicketOfficeStyles}
          operationDays={hours.hoursBusTicketingOffice}
        />
      )}
    </Box>
  );
}

HoursOperation.componentName = 'HoursOperation';

export default HoursOperation;
